import { EntityType } from '@frontend/common';
import { DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { ModuleType } from '@frontend/module/types';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { useModulesGrid } from './modules-grid.controller';

interface ModulesGridProps {
    spotId: string;
}

export const ModulesGrid = (props: ModulesGridProps) => {
    const viewProps = useModulesGrid(props);

    return (
        <DefaultContainer
            title={CommonMessage.OBJECTS.MODULE.PLURAL}
            content={
                viewProps.isLoading ? (
                    <div className='text-brand-muted flex w-full items-center justify-center py-4'>{CommonMessage.FORMS.LOADING_PLACEHOLDER}</div>
                ) : viewProps.modules.length === 0 ? (
                    <div className='text-brand-muted flex w-full items-center justify-center py-4'>
                        <FormattedMessage
                            id='Terminal.Stock.Adjust-stock.no-modules'
                            description='Terminal Adjust stock no modules found message'
                            defaultMessage='No modules found'
                        />
                    </div>
                ) : (
                    <>
                        <div className='grid w-full grid-cols-3 gap-2.5 2xl:grid-cols-5'>
                            {viewProps.modules.flat().map((module) => (
                                <div
                                    key={module.id}
                                    className='outline-brand-primary flex items-center justify-between rounded-md px-2.5 py-3.5 outline-1 outline-offset-[-1px]'>
                                    <PlatformObjectBadge
                                        entityType={EntityType.MODULE}
                                        id={module.id}
                                        display={module.index}
                                        key={module.id}
                                        parentIds={{
                                            spot_id: module.spot_id
                                        }}
                                    />
                                    <div className='flex flex-col gap-2.5'>
                                        {module.type && module.type === ModuleType.cabinet && (
                                            <div className='bg-brand-muted flex items-center justify-center rounded-full px-2 py-1'>
                                                <span className='text-background-surface text-center text-sm font-semibold'>
                                                    <FormattedMessage
                                                        id='modules-grid.module-type.cabinet'
                                                        defaultMessage='Cabinet'
                                                    />
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <DefaultSecondaryButton
                            text={CommonMessage.BUTTONS.VIEW_DETAILED_LIST}
                            onClick={() => viewProps.viewDetailedModules(props.spotId)}
                        />
                    </>
                )
            }
        />
    );
};
